export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-14.e701d586.png";